import axiosInstance from './axiosInstance';

export const getMyNotifications = (limit = 20) =>
    axiosInstance.get(`/Notification/GetMyNotifications?limit=${limit}`);

export const getUnreadCount = () =>
    axiosInstance.get("/Notification/GetUnreadCount");

export const markAsRead = (notificationId) =>
    axiosInstance.put(`/Notification/MarkAsRead?notificationId=${notificationId}`);

export const markAllAsRead = () =>
    axiosInstance.put("/Notification/MarkAllAsRead");

export const getPendingTasks = () =>
    axiosInstance.get("/Notification/GetPendingTasks");

export const getPendingTasksCount = () =>
    axiosInstance.get("/Notification/GetPendingTasksCount");

export const markTaskAsDone = (notificationId) =>
    axiosInstance.put(`/Notification/MarkTaskAsDone?notificationId=${notificationId}`);
